module.exports = "<template> <sio-log object.one-time=\"{id: object.id, modelId: object.modelId}\" tab.one-time=tab></sio-log> </template> ";